import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'
import {
  AI_RISK_REPORT_RENDER_MODE_VALUES,
  DEFAULT_AI_RISK_REPORT_RENDER_MODE,
  isAiRiskReportExportMode,
} from '../../data/renderMode'

const AIRiskReportRenderModeContext = createContext(DEFAULT_AI_RISK_REPORT_RENDER_MODE)

export function AIRiskReportRenderModeProvider({ renderMode = DEFAULT_AI_RISK_REPORT_RENDER_MODE, children }) {
  return <AIRiskReportRenderModeContext.Provider value={renderMode}>{children}</AIRiskReportRenderModeContext.Provider>
}

AIRiskReportRenderModeProvider.propTypes = {
  renderMode: PropTypes.oneOf(AI_RISK_REPORT_RENDER_MODE_VALUES),
  children: PropTypes.node.isRequired,
}

export const useAIRiskReportRenderMode = () => useContext(AIRiskReportRenderModeContext)

export const useAIRiskReportExportMode = () => isAiRiskReportExportMode(useAIRiskReportRenderMode())
